<template>
  <ul class="accordion">
    <li v-for="(item, i) in items" :key="item.question">
      <h3>
        <button
          type="button"
          class="accordion_question"
          :aria-expanded="open === i"
          :aria-controls="`faq-answer-${i}`"
          @click="open = open === i ? null : i"
        >
          {{ item.question }}
          <span class="accordion_sign" aria-hidden="true">{{ open === i ? '−' : '+' }}</span>
        </button>
      </h3>
      <div v-show="open === i" :id="`faq-answer-${i}`" class="accordion_answer">
        <p>{{ item.answer }}</p>
      </div>
    </li>
  </ul>
</template>

<script>
// Questions and answers, one open at a time. `items` is [{ question, answer }].

export default {
  name: 'SiteAccordion',

  props: {
    items: { type: Array, required: true },
  },

  data() {
    return { open: null }
  },
}
</script>

<style scoped>
.accordion li + li {
  margin-top: 12px;
}

.accordion h3 {
  margin: 0;
  font-size: inherit;
}

.accordion_question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  padding: 20px 24px;
  border: 1px solid var(--paper-line);
  border-radius: var(--radius);
  background: #fff;
  color: var(--ink);
  font: 700 20px/1.4 inherit;
  font-family: 'DM Sans', sans-serif;
  text-align: left;
  cursor: pointer;
}

.accordion_question[aria-expanded='true'] {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.accordion_sign {
  flex: none;
  color: var(--accent);
  font-size: 24px;
}

.accordion_answer {
  padding: 0 24px 24px;
  border: 1px solid var(--paper-line);
  border-top: 0;
  border-radius: 0 0 var(--radius) var(--radius);
  background: #fff;
}
</style>
